import { IconButton } from "@mui/material";
import { UserNewForm } from "Clients/Components/UserNewForm";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { AppRouting, getPath } from "Infrastructure/Utils/UrlUtils";
import { useUserDetailQuery } from "Clients/Api/Queries/useUserDetailQuery";

export const ClientNewPage: React.FunctionComponent = () => {
	const navigate = useNavigate();
	const { data, isLoading } = useUserDetailQuery(1);
	if (isLoading) return <div />;
	if (data?.status === 401) {
		navigate(getPath(AppRouting.SignIn));
	}

	return (
		<AuthenticatedLayout title="Nový uživatel">
			<IconButton onClick={(_e) => navigate(getPath(AppRouting.Users))}>
				<ArrowBackIcon />
			</IconButton>
			<UserNewForm />
		</AuthenticatedLayout>
	);
};
